import { createAction } from '@reduxjs/toolkit';

export const fetchTestimonials = createAction('testimonials/fetchTestimonials');
export const setTestimonialsSuccess = createAction('testimonials/setTestimonialsSuccess');
export const setTestimonialsError = createAction('testimonials/setTestimonialsError');
